import imageCompression from 'browser-image-compression'

import { DEFAULT_IMAGE_MAX_BYTES } from '../constants/channelLimits'

// Compresses `file` until it fits `maxBytes`, or throws `image_still_too_large`
// when even compression cannot get it under the ceiling. Callers catch that
// exact message to show a size-specific hint rather than a generic failure.
//
// `maxBytes` is a parameter because the ceiling is per-channel: Zalo allows 1MB
// while Facebook allows 25MB (see constants/channelLimits.js). It previously
// hardcoded Zalo's 1MB, which silently over-compressed Facebook images that
// needed no compression at all.
//
// The compressor targets 95% of the ceiling, not the ceiling itself, because
// browser-image-compression treats maxSizeMB as a goal it can overshoot; the
// headroom keeps a near-miss from tripping the post-check below.
export async function compressImageForUpload(file, maxBytes = DEFAULT_IMAGE_MAX_BYTES) {
  if (file.size <= maxBytes) return file

  const compressed = await imageCompression(file, {
    maxSizeMB: (maxBytes * 0.95) / (1024 * 1024),
    maxWidthOrHeight: 1920,
    useWebWorker: true,
    fileType: file.type,
  })

  if (compressed.size > maxBytes) {
    throw new Error('image_still_too_large')
  }
  return compressed
}
